// Process story (sections/blendin-process-story.liquid).
//
// The stage pins under the sticky header. Each step owns one track of scroll;
// within it the step's clip is scrubbed first frame to last on a canvas while
// its full-screen overlay fades in (first quarter), holds, and fades out (last
// quarter). Frames come as sprite sheets from Shopify Files, 12 frames each
// (4 across, 3 down): a 16:9 set for landscape screens and a 9:16 set for
// portrait. Only the steps around the reader are kept loaded, and sheets that
// fall out of range are released: phones (iOS Safari especially) cap decoded
// image memory, and once a sheet is dropped the stage would freeze on the
// nearest frame it still has.
//
// Reduced motion: the footage still follows the scroll, because it only moves
// when the reader moves it. What reduced motion removes is the overlay's
// slide-up, so the text only fades.

(function () {
  var PER_SPRITE = 12;
  var COLS = 4;
  var SIZE = { wide: [1280, 720], tall: [540, 960] };
  var BLANK = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  function init(root) {
    var story = root.querySelector('[data-bic-story-story]');
    var canvas = root.querySelector('.bic-story__canvas');
    if (!story || !canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    var steps = Array.prototype.slice.call(root.querySelectorAll('.bic-story__step'));
    var bars = root.querySelectorAll('.bic-story__rail i');
    var tracks = root.querySelectorAll('.bic-story__track');
    if (!steps.length || tracks.length !== steps.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var header = document.querySelector('.bic-header-section');
    var set = null;
    var sprites = {};
    var lastKey = '';
    var ticking = false;

    root.classList.add('is-enhanced');

    // Ways out of the pinned story. Phones: buy bar (price, Skip, Add to cart)
    // and an up chevron back to the buy box. Desktop: up chevron to the
    // section above, down chevron past the story, Add to cart lower right.
    // Every Add to cart mirrors the buy box button, so "Not available" after
    // the pre-order close carries over, and submits the buy box form itself.
    var mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
    var mainAtc = mainForm && mainForm.querySelector('.bic-pdp__atc');
    var storyAtcs = Array.prototype.slice.call(root.querySelectorAll('[data-bic-story-atc]'));
    var upChip = root.querySelector('[data-bic-story-up]');
    var barBar = root.querySelector('[data-bic-story-buybar]');
    var desktopMq = window.matchMedia('(min-width: 900px)');
    function syncAtc() {
      if (!mainAtc) {
        if (barBar) barBar.hidden = true;
        storyAtcs.forEach(function (b) { b.hidden = true; });
        return;
      }
      var label = (mainAtc.textContent || '').trim() || 'Add to cart';
      storyAtcs.forEach(function (b) { b.disabled = mainAtc.disabled; b.textContent = label; });
    }
    syncAtc();
    if (mainAtc) {
      if ('MutationObserver' in window) {
        new MutationObserver(syncAtc).observe(mainAtc, { attributes: true, childList: true, subtree: true, characterData: true });
      }
      storyAtcs.forEach(function (b) {
        b.addEventListener('click', function () {
          if (mainAtc.disabled) return;
          if (mainForm.requestSubmit) mainForm.requestSubmit(mainAtc);
          else mainAtc.click();
        });
      });
    }
    if (upChip) {
      upChip.addEventListener('click', function (e) {
        e.preventDefault();
        var behavior = reduce ? 'auto' : 'smooth';
        if (desktopMq.matches) {
          var sectionEl = root.closest('.shopify-section');
          var above = sectionEl && sectionEl.previousElementSibling;
          var target = above || root;
          var headerH = header ? header.getBoundingClientRect().height : 0;
          window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerH), behavior: behavior });
        } else if (mainAtc) {
          mainAtc.scrollIntoView({ block: 'center', behavior: behavior });
        }
      });
      var setUpLabel = function () {
        upChip.setAttribute('aria-label', desktopMq.matches ? 'Skip to the section above' : 'Back to Add to cart');
      };
      setUpLabel();
      if (desktopMq.addEventListener) desktopMq.addEventListener('change', setUpLabel);
    }

    function frameCount(i) { return parseInt(steps[i].getAttribute('data-frames'), 10) || 1; }

    function release(list) {
      (list || []).forEach(function (img) { img.onload = null; img.onerror = null; img.src = BLANK; });
    }

    function pickSet() {
      var want = window.innerHeight > window.innerWidth ? 'tall' : 'wide';
      if (want !== set) {
        Object.keys(sprites).forEach(function (s) { release(sprites[s]); });
        set = want; sprites = {}; lastKey = '';
      }
    }

    function load(url, retry) {
      var img = new Image();
      img.onload = requestUpdate;
      img.onerror = function () {
        // One retry for a dropped request or a decode the browser gave up on.
        if (!retry) setTimeout(function () { img.src = url + (url.indexOf('?') < 0 ? '?' : '&') + 'r=1'; }, 400);
        retry = true;
      };
      img.src = url;
      return img;
    }

    // Portrait (phones): the active step and the next one. Landscape: one
    // step either side, since desktops have the memory for it.
    function ensure(active) {
      var from = set === 'tall' ? active : active - 1;
      var to = active + 1;
      Object.keys(sprites).forEach(function (s) {
        if (+s < from || +s > to) { release(sprites[s]); delete sprites[s]; }
      });
      for (var s = Math.max(0, from); s <= Math.min(steps.length - 1, to); s++) {
        if (sprites[s]) continue;
        var urls = (steps[s].getAttribute('data-' + set) || '').split('|').filter(Boolean);
        sprites[s] = urls.map(function (url) { return load(url, false); });
      }
    }

    function ready(img) { return img && img.complete && img.naturalWidth; }

    function drawFrame(step, f) {
      var list = sprites[step];
      if (!list || !list.length) return;
      var total = frameCount(step);
      // Nearest loaded frame, so a sprite still downloading never blanks the stage.
      var pick = -1;
      for (var d = 0; d < total && pick < 0; d++) {
        var a = f - d, b = f + d;
        if (a >= 0 && ready(list[Math.floor(a / PER_SPRITE)])) pick = a;
        else if (b < total && ready(list[Math.floor(b / PER_SPRITE)])) pick = b;
      }
      if (pick < 0) return;
      var key = set + step + ':' + pick + ':' + canvas.width + 'x' + canvas.height;
      if (key === lastKey) return;
      lastKey = key;
      var img = list[Math.floor(pick / PER_SPRITE)];
      var fw = SIZE[set][0], fh = SIZE[set][1], local = pick % PER_SPRITE;
      var cw = canvas.width, ch = canvas.height;
      var sc = Math.max(cw / fw, ch / fh), w = fw * sc, h = fh * sc;
      ctx.drawImage(img, (local % COLS) * fw, Math.floor(local / COLS) * fh, fw, fh, (cw - w) / 2, (ch - h) / 2, w, h);
    }

    function layout() {
      var top = header ? header.getBoundingClientRect().height : 0;
      root.style.setProperty('--bic-story-top', Math.round(top) + 'px');
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(canvas.clientWidth * dpr);
      canvas.height = Math.round(canvas.clientHeight * dpr);
      lastKey = '';
    }

    function ramp(p) {
      if (p < 0.25) return p / 0.25;
      if (p > 0.75) return (1 - p) / 0.25;
      return 1;
    }

    function update() {
      ticking = false;
      var top = header ? header.getBoundingClientRect().height : 0;
      var stepLen = tracks[0].offsetHeight;
      var scrolled = top - story.getBoundingClientRect().top;
      var g = Math.max(0, Math.min(tracks.length - 0.0001, scrolled / stepLen));
      var active = Math.floor(g);
      var local = scrolled < 0 ? 0 : g - active;
      // Pinned while the stage is held under the header; the exits show only then.
      root.classList.toggle('is-pinned', scrolled >= 0 && scrolled < stepLen * tracks.length - 1);
      // Only do work while the story is near the viewport.
      var rect = story.getBoundingClientRect();
      if (rect.bottom < -window.innerHeight || rect.top > window.innerHeight * 2) return;
      ensure(active);
      for (var i = 0; i < bars.length; i++) {
        bars[i].style.width = (i < active ? 100 : i === active ? local * 100 : 0) + '%';
      }
      steps.forEach(function (el, i) {
        var o = i === active ? ramp(local) : 0;
        el.style.opacity = o;
        el.style.visibility = o > 0.01 ? 'visible' : 'hidden';
        el.style.setProperty('--bic-story-lift', reduce ? '0px' : ((1 - o) * 16) + 'px');
      });
      var total = frameCount(active);
      drawFrame(active, Math.round(local * (total - 1)));
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function onResize() { pickSet(); layout(); requestUpdate(); }

    // Horizontal scrolling also drives the story (owner 2026-09-17). While the
    // stage is pinned, a sideways trackpad scroll or a sideways swipe moves the
    // page vertically by the same amount: right or a leftward swipe goes
    // forward, left or a rightward swipe goes back. Vertical gestures are left
    // to the browser, and the page releases at either end as usual.
    function isPinned() { return root.classList.contains('is-pinned'); }

    window.addEventListener('wheel', function (e) {
      if (!isPinned() || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      var dx = e.deltaMode === 1 ? e.deltaX * 16 : e.deltaX;
      window.scrollBy(0, dx);
    }, { passive: false });

    var touch = null;
    window.addEventListener('touchstart', function (e) {
      touch = null;
      if (!isPinned() || e.touches.length !== 1) return;
      touch = { x: e.touches[0].clientX, y: e.touches[0].clientY, axis: null };
    }, { passive: true });
    window.addEventListener('touchmove', function (e) {
      if (!touch || e.touches.length !== 1) return;
      var x = e.touches[0].clientX, y = e.touches[0].clientY;
      if (!touch.axis) {
        var dx0 = Math.abs(x - touch.x), dy0 = Math.abs(y - touch.y);
        if (Math.max(dx0, dy0) < 8) return;
        touch.axis = dx0 > dy0 ? 'x' : 'y';
      }
      if (touch.axis !== 'x') return;
      e.preventDefault();
      window.scrollBy(0, touch.x - x);
      touch.x = x;
    }, { passive: false });
    window.addEventListener('touchend', function () { touch = null; }, { passive: true });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', onResize);
    onResize();
  }

  function boot() {
    document.querySelectorAll('[data-bic-story]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
